<template>
  <img
    v-if="getSrc"
    :src="getSrc"
    :alt="alt"
    :loading="loading"
    @error="handleError"
  />
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
/**
 * Image component whose src can be a string representing a single image path, or an array of many image path strings.  In the case of the array, the first src will be loaded by default, with each subsequent src loaded as a fallback.
 *
 * ```jsx
 * import xImg from '@/components/shared/x-img'
 *
 * <x-img src="/path/to/image.jpg" />
 * ```
 */

export default {
  name: 'XImg',
  props: {
    src: {
      type: [String, Array],
      required: true,
    },
    alt: {
      type: [String, null],
      default: '',
    },
    loading: {
      type: String,
      default: 'lazy',
      validator: (value) => ['lazy', 'eager'].indexOf(value) !== -1,
    },
  },
  data() {
    return {
      srcIndex: 0,
    }
  },
  computed: {
    getSrc() {
      if (Array.isArray(this.src)) {
        return this.src[this.srcIndex]
      }
      return this.src
    },
  },
  watch: {
    src() {
      // If src array is updated, set index to 0 to rerun handleError and
      // find first loading image url
      this.srcIndex = 0
    },
  },
  methods: {
    handleError() {
      // There was an error loading the image try the fallback srcs
      if (Array.isArray(this.src) && this.srcIndex < this.src.length) {
        this.srcIndex++
      }
    },
  },
}
</script>
